// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditorContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { observer } from 'mobx-react';
import React, { PropTypes } from 'react';
import PropertiesEditorModel from 'logic/models/Izenda.PropertiesEditor';
import PropertiesEditorManager from 'modules/Izenda.PropertiesEditorManager';
import PropertiesEditor from './Izenda.PropertiesEditor';

@observer
class PropertiesEditorContainer extends React.Component {
  static displayName = "PropertiesEditorContainer";
  static propTypes = {
    propertyConfig: PropTypes.object,
    editorName: PropTypes.string,
    className: PropTypes.string
  };

  setPropertySchema(propertyConfig: Object) {
    this.propertyConfig = propertyConfig || {};
  }

  buildSchemaData(props: Object) {
    const propertyConfig = props.propertyConfig || this.propertyConfig || {};
    this.propertiesEditorModel.setPropertyConfig(propertyConfig);
    this.schemaData = this.propertiesEditorModel.getDataBySchema();
  }

  componentWillUpdate(nextProps: Object) {
    if (
      nextProps.editorName &&
      nextProps.editorName !== this.props.editorName
    ) {
      PropertiesEditorManager.resetEditor(this.props.editorName);
      PropertiesEditorManager.addEditor(this, nextProps.editorName);
    }
    this.buildSchemaData(nextProps);
  }

  componentWillMount() {
    const editorName = this.props.editorName;
    editorName && PropertiesEditorManager.addEditor(this, editorName);

    this.propertiesEditorModel = new PropertiesEditorModel();
    this.buildSchemaData(this.props);
  }

  componentWillUnmount() {
    const editorName = this.props.editorName;
    editorName && PropertiesEditorManager.resetEditor(editorName);
  }

  render() {
    const propertyConfig =
      this.props.propertyConfig || this.propertyConfig || {};    

    return (
      <PropertiesEditor
        {...propertyConfig}
        className={this.props.className}
        propertiesEditorModel={this.propertiesEditorModel}
        schemaData={this.schemaData}
        closePopover={this.props.closePopover}
      />
    );
  }
}

export default PropertiesEditorContainer;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.PropertiesEditorContainer.js